import get from 'lodash/get'
import { collections } from '../../../common/constants'
const state = {
  sites: [],
  currentSite: null,
}

const getters = {
  sites: (state) => state.sites,
  currentSite: (state) => state.currentSite,
  // TODO: worksite only, see mixin/customers.js
  currentAccessKey: (state) =>
    get(state, 'currentSite._source.mapboxglApiKey', null),
  currentSiteName: (state) => get(state, 'urrentSite._source.siteName', null),
  // TODO: worksite only: defaultFloor exists on each site kind in mappings,
  // but in practice it is never populated on created renter sites & is undefined.
  currentDefaultFloor: (state) =>
    get(state, 'currentSite._source.defaultFloor', null),
  // TODO: worksite only
  currentAreas: (state) => get(state, 'currentSite._source.area', []),
  floors: (state) => get(state, 'currentSite._source.floors', []),
  // TODO: worksite only
  floorsPlans: (state) =>
    // TODO MGA: default value when no floorPlans prop exist ????
    get(state, 'currentSite._source.floorsPlans', []),
  // TODO: worksite only
  datasetId: (state) => get(state, 'currentSite._source.datasetId', null),
}

const actions = {
  FETCH_SITES: async ({ commit, rootGetters }, kuzzle) => {
    if (!rootGetters['auth/currentIndex']) {
      return
    }
    const sites = []
    try {
      await kuzzle.collection.refresh(
        rootGetters['auth/currentIndex'],
        collections.SITES,
      )

      let searchResult = await kuzzle.document.search(
        rootGetters['auth/currentIndex'],
        collections.SITES,
        {},
        {
          scroll: '30s',
        },
      )
      while (searchResult) {
        searchResult.hits.forEach((hit) => {
          sites.push(hit)
        })
        searchResult = await searchResult.next()
      }
    } catch (error) {
      console.error(error)
      throw error
    }
    //TODO MGA: boom current site is a dumb "first site found" rule in array of sites fetched for current customer. TOFIX: use locally saved current site if any ! and update it when changed (renter sites)
    commit('SET_CURRENT_SITE', sites[0])
    commit('SET_SITES', sites)
  },
}

const mutations = {
  SET_CURRENT_SITE: (state, site) => {
    state.currentSite = site
  },
  SET_SITES: (state, sites) => {
    state.sites = sites
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
